import { render } from "./MessageDialog.vue?vue&type=template&id=25de49f3&scoped=true"
import script from "./MessageDialog.vue?vue&type=script&lang=js"
export * from "./MessageDialog.vue?vue&type=script&lang=js"

import "./MessageDialog.vue?vue&type=style&index=0&id=25de49f3&scoped=true&lang=css"

import exportComponent from "/home/glassplant/agi.co.jp/roots-prod/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25de49f3"]])

export default __exports__